import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The type of the payment instrument associated to the vaulted payment method.`}</p>
    <p>{`Examples of possible values (new values could be added as we add new payment methods):`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`APPLE_PAY`}</inlineCode>{`  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`CARD_OFF_SESSION_PAYMENT`}</inlineCode>{`  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`GOOGLE_PAY`}</inlineCode>{`  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`KLARNA_CUSTOMER_TOKEN`}</inlineCode>{`  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`OFF_SESSION_PAYMENT`}</inlineCode>{`  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`PAYMENT_CARD`}</inlineCode>{`  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`PAYPAL_BILLING_AGREEMENT`}</inlineCode>{`  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`PAYPAL_ORDER`}</inlineCode>{`  `}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      